import Header from "./elements/header.js"
import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { ReactSession } from "../../lib/secure_reactsession";
import { getProfile } from "../../services/user.js";
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import { FullPageLoadingIcon } from "../loader/full_page_loader_lcon.js";

export default function Layout(props) {
    const navigate = useNavigate();
    const [isLoading, setLoading] = useState(false);

    ReactSession.setStoreType("localStorage");

    useEffect(() => {
        const user = ReactSession.get("user");
        const token = ReactSession.get("token");

        if (!props.skipCheckLogin) {
            if (user.role == "Tester" && user.completed_step != 8 && !props.skipCheck) {
                getProfile(token).then(response => {
                    setLoading(false);

                    if (response.success) {
                        if (response.data.user.completed_step != 8) {
                            navigate('/profile/step1');
                        }
                    }
                });
            }
        }
    }, []);
    const getFooterYear = () => {
        const d = new Date(); let year = d.getFullYear(); return <>{year}</>;
    }
    return (
        <SkeletonTheme baseColor="#dae5f1" highlightColor="#ebf4ff">
            <div className={`inner-page-wrapper${(isLoading || props.isLoading) ? '-1' : ''} ${props.wrapClass} `}>
                {(isLoading || props.isLoading) &&
                    <FullPageLoadingIcon />
                }
                {(!isLoading && !props.isLoading) &&
                    <>
                        <Header fixed_header_target={props.fixed_header_target} skipCheckLogin={props.skipCheckLogin} username={props.username} activeMenu={props.activeMenu} setCreditZero={props.setCreditZero} profileCompleted={props.profileCompleted} />
                        <div className={`${(props.extended404Footer === false) ? '' : (props.isFullWidth) ? '' : 'container inner-page-container'}`}>
                            <>{props.children}</>
                        </div>
                        {props.extendedFooter &&
                            <>
                                <div className="full home-marquee-banner section">
                                    <div className="home-marque-banner-box">
                                        <div className="scrolling-box">Privacy is important</div>
                                        <div className="scrolling-box" aria-hidden="true"> Privacy is important</div>
                                        <div className="scrolling-box" aria-hidden="true"> Privacy is important</div>
                                        <div className="scrolling-box" aria-hidden="true"> Privacy is important</div>
                                        <div className="scrolling-box" aria-hidden="true"> Privacy is important</div>
                                        <div className="scrolling-box" aria-hidden="true"> Privacy is important</div>
                                        <div className="scrolling-box" aria-hidden="true"> Privacy is important</div>
                                        <div className="scrolling-box" aria-hidden="true"> Privacy is important</div>
                                        <div className="scrolling-box" aria-hidden="true"> Privacy is important</div>
                                        <div className="scrolling-box" aria-hidden="true"> Privacy is important</div>
                                        <div className="scrolling-box" aria-hidden="true"> Privacy is important</div>
                                        <div className="scrolling-box" aria-hidden="true"> Privacy is important</div>
                                        <div className="scrolling-box" aria-hidden="true"> Privacy is important</div>
                                        <div className="scrolling-box" aria-hidden="true"> Privacy is important</div>
                                        <div className="scrolling-box" aria-hidden="true"> Privacy is important</div>
                                    </div>
                                </div>

                                <div className="full homeafooterbox section researcher-homeafooterbox">
                                    <div className="container inner-page-container">
                                        <div className="footerboxhome minicontainer-outer">
                                            <div className="minicontainer">
                                                <div className="row">
                                                    <div className="col-xs-12 col-sm-12 col-md-12 homefooterbox-headingbox">
                                                        <div className="h1">At User<span>Q</span>, we take your<br /> data privacy and security<br /> seriously</div>
                                                    </div>
                                                    <div className="col-xs-12 col-sm-12 col-md-12 homefooterbox-infobox">
                                                        <div className="row align-items-center">
                                                            <div className="col-xs-12 col-sm-12 col-md-5 homefooterbox-left">
                                                                <div className="full homefooterbox-info">
                                                                    <p>GDPR is a European Union regulation, designed to improve the data security and privacy of European citizens. Basically, companies in Europe have to make sure your data is safe, and that you can access and control it.</p>
                                                                    <p>Our Privacy Policy was prepared in accordance with the GDPR.</p>
                                                                </div>
                                                            </div>
                                                            <div className="col-xs-12 col-sm-12 col-md-7 homefooterbox-right">
                                                                <div className="full homefooterbox-imgbox"> <img src="images/Frame-257.png" alt="UserQ" /></div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        }

                        {(props.extended404Footer !== false) &&
                            <footer className="researcher-footer">
                                <div className="container inner-page-container">
                                    <div className="footerbottom-bar">
                                        <div className="row">
                                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 ">
                                                <div className="footer-left-side-data">
                                                    <span>&copy; {getFooterYear()} USERQ. All rights reserved.</span>
                                                </div>
                                            </div>
                                            <div className="col-xs-12 col-sm-12 col-md-6 col-lg-6 footerbottom-bar-right">
                                                <div className="footerbottom-bar-right-inner">
                                                    <span className={"terms-of-use-txt-link-dsk"}><a href="https://userq.com/terms-of-use/">Terms of use</a></span>
                                                    <span className={"privacy-policy-txt-link-dsk"}><a href="https://userq.com/privacy-policy/">Privacy policy</a></span>
                                                    <span className="cookie-link"><a href="https://userq.com/privacy-policy/#cookies-policy">Cookie policy <img
                                                        src={process.env.REACT_APP_URL + "images/cookie-icon.svg"}
                                                        alt="img" /></a></span>
                                                    <span className="proudly-saying-text">
                                                        Proudly created by <a
                                                            href="https://www.digitalofthings.com/" target="_blank">Digital Of Things</a>                                </span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </footer>
                        }
                    </>
                }
            </div>
        </SkeletonTheme>
    )
}